(function() {
    'use strict';

    angular.module('app').directive('validateCreditCard', validateCreditCard);

    function validateCreditCard() {
        return {
            restrict: 'A',
            link: link,
            require: 'ngModel'
        };

        function link(scope, element, attrs, ctrl) {
            element.ready(apply);

            function apply() {
                $(element).validateCreditCard(function(result) {
                    var $cardType = $('.credit-card__type-icon').removeClass('fa-credit-card fa-cc-amex fa-cc-discover fa-cc-mastercard fa-cc-visa');
                    try {
                        if (result.card_type.name === 'visa') {
                            $cardType.addClass('fa-cc-visa');
                        } else if (result.card_type.name === 'mastercard') {
                            $cardType.addClass('fa-cc-mastercard');
                        } else if (result.card_type.name === 'discover') {
                            $cardType.addClass('fa-cc-discover');
                        } else if (result.card_type.name === 'amex') {
                            $cardType.addClass('fa-cc-amex');
                        } else {
                            $cardType.addClass('fa-credit-card');
                        }
                    } catch (e) {
                        $cardType.addClass('fa-credit-card');
                    }
                    if (result.valid) {
                        $(this).closest('.credit-card').addClass('is-valid');
                    } else {
                        $(this).closest('.credit-card').removeClass('is-valid');
                    }
                });
            }

            function cardValidator(ngModel) {
                $(element).validateCreditCard(function(result) {
                    if (result.valid) {
                        ctrl.$setValidity('uppercaseValidator', true);
                    } else {
                        ctrl.$setValidity('uppercaseValidator', false);
                    }
                });
                return ngModel;
            }

        ctrl.$parsers.push(cardValidator);
        }
    }

})();
